// extracted by mini-css-extract-plugin
export default {"mainCont":"SimStorage_mainCont__XV1M+","wrCont":"SimStorage_wrCont__ebM94","suCont":"SimStorage_suCont__ox7YM"};